import { ActionsUnion, createAction } from "../../../store/definitions";
import { DriverSafetyActionTypes, IDriverSafetyDataStore } from "./types";

export interface IDriverSafetyPayload {
    userId: string | undefined;
    driverSafety: IDriverSafetyDataStore[];
}

export const DriverSafetyActions = {
    setDriverSafetyInsight: (payload: IDriverSafetyPayload) => createAction(DriverSafetyActionTypes.SET_DRIVER_SAFETY_INSIGHT, payload),
    clearDriverSafetyInsight: (payload: string | undefined) => createAction(DriverSafetyActionTypes.CLEAR_DRIVER_SAFETY_INSIGHT, payload)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type DriverSafetyActions = ActionsUnion<typeof DriverSafetyActions>;
